var exports = {
  "sz": "x28a7bf27--f8e8bf--offers-container",
  "gK": "x28a7bf27--f8e8bf--main-container",
  "e": "x28a7bf27--f8e8bf--text-container",
  "Sl": "x28a7bf27--f8e8bf--image",
};

module.exports = exports;
